import * as ActionTypes from '../constants/actionTypes'
import { roleCreate, roleRead, roleUpdate, roleDelete } from '../api/role'

export const editForm = formFieldsChange => ({
  type: ActionTypes.ROLEFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.ROLEFORM_ENTER_RESET,
})

export const fetchItem = values => (dispatch) => {
  console.log(values)
  dispatch({ type: ActionTypes.ROLEFORM_FETCHITEM_LOAD })

  roleRead(values).then((res) => {
    const item = res.result

    dispatch({
      type: ActionTypes.ROLEFORM_FETCHITEM_SUCCEED,
      item,
    })
    dispatch({
      type: ActionTypes.ROLEFORM_EDITFORM_CHANGE,
      field: {
        id: { name: 'idnum', value: item.idnum },
        s_name: { name: 's_name', value: item.s_name },
        n_identity: { name: 'n_identity', value: item.n_identity },
      },
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ROLEFORM_FETCHITEM_FAIL,
      fetchItemError: 'Ошибка получения данных по роли.',
    })
  })
}

export const createItem = values => (dispatch) => {
  // console.log(values)
  dispatch({ type: ActionTypes.ROLEFORM_CREATEITEM_LOAD })
  roleCreate(values).then(() => {
    // dispatch({ type: ActionTypes.SELLERLIST_CHANGETABLE_CHANGE })
    dispatch({ type: ActionTypes.ROLEFORM_CREATEITEM_SUCCEED })
    dispatch({ type: ActionTypes.ROLEFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ROLEFORM_CREATEITEM_FAIL,
      createItemError: 'Ошибка создания роли.',
    })
  })
}

export const editItem = params => (dispatch) => {
  dispatch({ type: ActionTypes.ROLEFORM_EDITITEM_LOAD })

  roleUpdate(params).then(() => {
    dispatch({ type: ActionTypes.ROLEFORM_EDITITEM_SUCCEED })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ROLEFORM_EDITITEM_FAIL,
      editItemError: 'Ошибка изменения данных.',
    })
  })
}

export const deleteItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.ROLEFORM_DELETEITEM_LOAD })

  roleDelete(values).then(() => {
    dispatch({ type: ActionTypes.ROLEFORM_DELETEITEM_SUCCEED })
    dispatch({ type: ActionTypes.ROLEFORM_ENTER_RESET })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ROLEFORM_DELETEITEM_FAIL,
      deleteItemError: 'Ошибка удаления роли.',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/roleForm.js